var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"oauth-login d-flex flex-grow-1 align-items-center justify-content-center",attrs:{"id":"main"}},[_c('wc-loaders-cube')],1)}
var staticRenderFns = []

export { render, staticRenderFns }